<template>
  <v-list subheader>
    <v-subheader v-if="showHeader">{{
      $tc('entetes.telephone', telephones.length + delta)
    }}</v-subheader>
    <v-input :rules="[serveurRule(itemPath)]" hide-details="auto" />

    <slot name="premier" />

    <template v-if="readonly">
      <template v-for="(telephone, index) in telephones">
        <telephoneListItem
          :key="`telephone${index}`"
          :disabled="isDisabled(telephone)"
          :telephone="telephone"
        />
      </template>
    </template>
    <template v-else>
      <template v-for="(telephone, index) in telephones">
        <v-menu
          v-model="telephone.modal"
          :close-on-content-click="false"
          max-width="450px"
          transition="scale-transition"
          :key="`telephone${index}`"
          @input="editionTelephone(telephone)"
        >
          <template #activator="{ on, attrs }">
            <telephoneListItem
              v-bind="attrs"
              v-on="on"
              :disabled="isDisabled(telephone)"
              :telephone="telephone"
              :itemPath="`${itemPath}[${index}]`"
              :analyseDiff="analyseDiff"
              :rules="[nestedServeurRule(`${itemPath}[${index}]`)]"
            >
              <template #action>
                <v-list-item-action
                  v-if="analyseDiff.supprime[`${itemPath}[${index}]`]"
                >
                  <v-btn
                    icon
                    @click.stop="annulerSuppression(`${itemPath}[${index}]`)"
                  >
                    <v-icon>undo</v-icon>
                  </v-btn>
                </v-list-item-action>

                <v-list-item-action v-else>
                  <v-btn
                    icon
                    @click.stop="supprimerTelephone(telephone, index)"
                  >
                    <v-icon>delete</v-icon>
                  </v-btn>
                </v-list-item-action>
              </template>
            </telephoneListItem>
          </template>

          <telephoneEditeur
            v-model="edition"
            titre="Éditer un téléphone"
            :telephones="enums.telephones"
            :itemPath="`${itemPath}[${index}]`"
            :showHeader="showHeader"
            @change="valider(telephone)"
            @annuler="annuler(telephone)"
          />
        </v-menu>
      </template>
      <v-subheader class="d-flex justify-center">
        <v-menu
          v-model="ajout"
          :close-on-content-click="false"
          max-width="450px"
          transition="scale-transition"
          @input="editionTelephone({})"
        >
          <template #activator="{ on, attrs }">
            <v-btn v-bind="attrs" v-on="on" small outlined color="secondary"
              >Ajouter un téléphone</v-btn
            >
          </template>

          <telephoneEditeur
            v-model="edition"
            titre="Ajouter un téléphone"
            :telephones="enums.telephones"
            @change="ajouter()"
            @annuler="annulerAjout"
          />
        </v-menu>
      </v-subheader>
    </template>
  </v-list>
</template>

<script>
import { copieTelephone } from './telephoneUtil.js';
import { defaultDiff } from '@/utils/diff.js';

import ServeurRule from '@/plugins/mixins/ServeurRule';
function copieTelephones(value, avecModal) {
  if (!value) return [];
  const telephones = value.map(t => {
    const out = copieTelephone(
      {
        id: t.id,
        ordre: t.ordre,
      },
      t,
    );
    if (avecModal) out.modal = false;
    return out;
  });
  telephones.sort((l, r) => l.ordre - r.ordre);
  return telephones;
}

export default {
  mixins: [ServeurRule],
  inject: ['errors'],
  props: {
    showHeader: {
      type: Boolean,
      default: true,
    },
    value: {
      type: Array,
    },
    delta: {
      type: Number,
      default: 0,
    },
    itemPath: {
      type: String,
      default: '',
    },
    readonly: {
      type: Boolean,
    },
    donneesConfidentiellesVisibles: {
      type: Boolean,
      default: true,
    },
    analyseDiff: {
      type: Object,
      default: defaultDiff,
    },
  },
  data() {
    return {
      telephones: copieTelephones(this.value, true),
      edition: {
        numero: null,
        libelle: null,
        confidentiel: null,
        smsAccepte: null,
        codePoste: null,
      },
      ajout: false,
      enums: {
        telephones: ['Téléphone professionnel', 'Téléphone portable'],
      },
    };
  },
  watch: {
    value(newValue) {
      this.telephones = copieTelephones(newValue);
    },
  },
  methods: {
    isDisabled(telephone) {
      return telephone.confidentiel && !this.donneesConfidentiellesVisibles;
    },
    editionTelephone(telephone) {
      this.edition = copieTelephone({}, telephone);
    },
    valider(telephone) {
      telephone.modal = false;
      copieTelephone(telephone, this.edition);
      this.publier();
    },
    annulerSuppression(path) {
      this.$emit('annulerSuppression', path);
    },
    supprimerTelephone(telephone, index) {
      this.telephones.splice(index, 1);
      this.publier();
    },
    annuler(telephone) {
      telephone.modal = false;
    },
    ajouter() {
      const telephone = copieTelephone(
        {
          id: null,
        },
        this.edition,
      );
      this.telephones.push(telephone);
      this.ajout = false;
      this.publier();
    },
    annulerAjout() {
      this.ajout = false;
    },
    publier() {
      const out = copieTelephones(this.telephones);
      this.$emit('input', out);
    },
  },
};
</script>
